import React from "react";
import { useState } from "react";
import {
  IconButton,
  Paper,
  Typography,
  Button,
  Divider,
  useMediaQuery,
} from "@mui/material";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const ExpandInfo = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleIsExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div style={{ marginLeft: isMobile ? 0 : 34 }}>
      <div
        onClick={handleIsExpanded}
        style={{ display: "flex", alignItems: "center" }}
      >
        <Typography variant="h6" sx={{ mt: 2 }}>
          Află mai multe
        </Typography>
        {isExpanded ? (
          <ExpandLessIcon sx={{ mt: "22px", ml: 2, color: "#29348f" }} />
        ) : (
          <ExpandMoreIcon sx={{ mt: "22px", ml: 2, color: "#29348f" }} />
        )}
      </div>
      {isExpanded ? (
        <div>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Elaborare Studiu de Soluție cu Terți
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./Conventie-de-atribuire-Sucursala-7-modif2-2023.doc"
              style={{ color: "#0D6D92" }}
            >
              Convenție de Atribuire Sucursală
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Persoane fizice si juridice care au puterea instalata pe producere
            &lt;= 400kW;Autoritati publice locale indiferent de puterea
            instalata pe producere
          </Typography>
          <Typography variant="body2" sx={{ mt: 2, ml: 3 }}>
            <a
              href="./1.-Loc-consum-si-producere-nou-_Anexa-nr-1.docx"
              style={{ color: "#0D6D92" }}
            >
              a. Cerere Loc consum si producere nou (Anexa 1)
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0, ml: 3 }}>
            <a
              href="./2.-Loc-de-consum-existent_Anexa-nr-2.docx"
              style={{ color: "#0D6D92" }}
            >
              b. Notificare Loc consum existent (Anexa 2)
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0, ml: 3 }}>
            <a
              href="./3.-Loc-de-consum-si-producere-existent-actualizare-CRR_Anexa-nr-3.docx"
              style={{ color: "#0D6D92" }}
            >
              c. Notificare Loc consum si producere existent actualizare CRR
              (anexa 3)
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0, ml: 3 }}>
            <a
              href="./4.-Loc-consum-si_sau-producere-existent-Spor-Putere_Anexa-nr-1.docx"
              style={{ color: "#0D6D92" }}
            >
              d. Cerere Loc consum existent Spor de Putere (Anexa 1)
            </a>
          </Typography>

          <Typography variant="body2" sx={{ mt: 3 }}>
            Cererile tip de racordare sunt diferenţiate funcţie de categoria de
            utilizator din care face parte solicitantul:
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Consumator (mic) noncasnic.doc"
              style={{ color: "#0D6D92" }}
            >
              Consumator (mic) noncasnic{" "}
            </a>{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Consumator (mare) noncasnic.doc"
              style={{ color: "#0D6D92" }}
            >
              Consumator (mare) noncasnic{" "}
            </a>{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Producator.doc" style={{ color: "#0D6D92" }}>
              Producator{" "}
            </a>{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Autoproducator.doc" style={{ color: "#0D6D92" }}>
              Autoproducător
            </a>{" "}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Persoane fizice si juridice care au puterea instalata pe producere mai mare de  400kW.doc"
              style={{ color: "#0D6D92" }}
            >
              Prosumatori{" "}
            </a>{" "}
          </Typography>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ExpandInfo;
